<template>
  <div>
    <b-row>

      <b-col cols="12" class="my-2">
        <h5 class="mb-0">Derivacion.</h5>
        <small class="text-muted">
          Ingrese la información de la derivacion.
        </small>
      </b-col>

      <b-col cols="12">
        <b-card
          v-if="paciente"
          style="border: 1px solid #0080C9"
        >
          <b-row>
            <b-col>
              <b-row>
                <span class="col-12">
                  <b>Paciente:</b> 
                  <span v-if="paciente"> {{ paciente.nombre }}</span>
                </span>
              </b-row>

              <b-row>
                <span class="col-12">
                  <b>Fecha Derivacion:</b> 
                  {{fechaDerivacion}}
                </span>
              </b-row>
            </b-col>

            <b-col>
              <b-row>
                <span class="col-12">
                  <b>Tipo de Atencion:</b>
                  <span v-if="tipoAtencion"> {{ tipoAtencion.text }} </span>
                </span>
              </b-row>

              <b-row v-if="showEspecialidad && dataForm.especialidad">
                <span class="col-12">
                  <b>Especialidad Derivada:</b>
                  {{ dataForm.especialidad.text }}
                </span>
              </b-row>

              <b-row>
                <span class="col-12">
                  <b>Nivel Derivacion:</b>
                  {{ nivelDerivacion }}
                </span>
              </b-row>
            </b-col>
          </b-row>

        </b-card>
      </b-col>
    </b-row>


    <b-row class="my-1">
      <b-col class="d-flex align-items-center justify-content-end">
        <label> Es urgente? </label>
        <b-form-checkbox 
          switch 
          v-model="dataForm.esUrgente" 
          class="ml-2 mb-0"
        >
          {{ dataForm.esUrgente ? 'Si' : 'No' }}
        </b-form-checkbox>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="6">
        <label>Tipo de Documento: <span class="text-danger">*</span></label>
        <v-select
          v-model="dataForm.tipoDerivacion"
          :options="tipoDerivacionOpts"
          label="text"
          @input="onTipoDerivacionChange"
          :disabled="tipoDerivacionOpts.length === 0"
        />
        
        <div v-if="errors.length > 0" class="invalid-feedback">
          {{ errors[0] }}
        </div>
      </b-col>

      <b-col md="6">
        <b-form-group label-for="v-horacita">
          <label>Motivo de Derivacion:
            <span class="text-danger">*</span>
          </label>
          <v-select
            v-model="dataForm.motivoDerivacion"
            :options="motivoDerivacionOpts"
            :reduce="option => option"
            label="text"
            taggable
            :disabled="dataForm.tipoDerivacion && dataForm.tipoDerivacion.value === '3'"
          />
         
          <b-form-textarea v-model="dataForm.observacion_motder" class="mt-1"  placeholder="Describa otros..." v-if="dataForm.motivoDerivacion && dataForm.motivoDerivacion.value === '10'"></b-form-textarea>

          <div v-if="errors.length > 0" class="invalid-feedback">
            {{ errors[0] }}
          </div>
        </b-form-group>
      </b-col>
      <!-- <b-col md="5">
        <b-form-group label-for="v-motdesc">
          <label>Describa el motivo:
            <span class="text-danger">*</span>
          </label>
        
          <b-form-textarea
            v-model="dataForm.observacion_motder"
            
            label="text"
           
          />

          <div v-if="errors.length > 0" class="invalid-feedback">
            {{ errors[0] }}
          </div>
        </b-form-group>
      </b-col> -->
    </b-row>

    <b-row>
      <b-col cols="6" class="mb-1">
        <label>Cuadro clinico:</label>
        <b-form-textarea 
          v-model="dataForm.cuadroClinico" 
          rows="4"
        />
      </b-col>

      <b-col cols="6" class="mb-1">
        <label>Hallazgos:</label>
        <b-form-textarea 
          v-model="dataForm.hallazgos" 
          rows="4"
        />
      </b-col>
    </b-row>

  </div>
</template>

<script>
import { mapState } from "vuex";
import vSelect from "vue-select";
import { addUniqueNewOpt, getItemByValueId } from '@/shared/helpers';
import { derivacionesService  } from "../../services";

export default {

  name: 'StepInformacionDerivacion',

  components: {
    vSelect,
  },

  data() {
    return {
      fechacita:null,
      searchQueryPaciente: null,
      errors: [],
      tipoDerivacionOpts: [],
      motivoDerivacionOpts: [],

      loadInicial: false,

      dataForm:{
        observacion_motder: '',
        tipoDerivacion    : null,
        motivoDerivacion  : null,
        nivelDerivacion   : null,
        esUrgente         : false,
        hallazgos         : null,
        cuadroClinico     : null
      },

      flatpickrConfig: {
        allowInput: true, // Muestra un campo de entrada de texto adicional
        minDate:'1900-01-01',
        maxDate:new Date(),
        static: true
      },

      tipoAtencionOpts: [
        { value: '1', text: "Consulta Externa" },
        { value: '2', text: "Laboratorio" },
        { value: '3', text: "Imagen" },
        { value: '4', text: "Procedimientos Diagnósticos" },
        { value: '5', text: "Hospitalización" },
        { value: '6', text: "Emergencia" },
        { value: '7', text: "Tratamiento Integral Oncologico" }
      ]
    }
  },
  created() {
    this.loadInitData();
  },

  methods: {
    onAddUniqueNewOpt(newArray) {
      return addUniqueNewOpt(newArray);
    },

    async loadInitData(){
      this.tipoDerivacionOpts   = await derivacionesService.getTiposSelect();
      this.motivoDerivacionOpts = await derivacionesService.getMotivosSelect();
      console.log("motivoder:", this.motivoDerivacionOpts);
      console.log("tipoDerivacionOpts:", JSON.stringify(this.tipoDerivacionOpts, null, 2));
    },

    onInput() {
      if (this.searchQuery.length >= 3) {
        this.fetchPacientes(this.searchQuery);
      } else {
        this.filteredItems = [];
      }
    },
    onTipoDerivacionChange(value) {
      console.log('onTipoDerivacionChange: tipoDerivacion cambiado a', JSON.stringify(value, null, 2)); 
      this.$store.commit("setDerivacionesDataForm", { ...this.dataForm, tipoDerivacion: value });
    }
  },


  computed: {
    ...mapState({
      stData: state => state.derivaciones.modalCompletarDerivacion.zData,
    }),


    showEspecialidad(){
      const show = ['2', '3'].some((item) => item === this.stData?.tipoAtencion);
      return !show;
    },


    fechaDerivacion() {

      if ( !this.stData ) return null;
      return this.stData.fechaDerivacion
    },


    paciente() {
      const stPaciente = this.stData.atenmedId.cita.paciente;
      if ( !stPaciente ) return null; 

      const paciente = {
        id: stPaciente.id,
        nombre: `${stPaciente.persona.primerApellido} ${stPaciente.persona.primerNombre}`,
      };

      return paciente;
    },


    tipoAtencion(){
      const tipoAtencionId = this.stData?.tipoAtencion;
      if(!tipoAtencionId) return null;
      const item = getItemByValueId(this.tipoAtencionOpts, tipoAtencionId);
      return item;
    },


    nivelDerivacion(){
      // const user = JSON.parse(localStorage.getItem('detalleusuario'));
      // const establecimiento = user.establecimiento ? user.establecimiento.id : "";
      // let nivel = null;

      // if (['1', '3', '4'].some(id => id === establecimiento)) 
      //   nivel = 1;

      // if (['2', '5', '6'].some(id => id === establecimiento)) 
      //   nivel = 2;

      // this.dataForm.nivelDerivacion = nivel;
      
      // return nivel;

      if ( !this.stData ) return null;
      return this.stData.nivelDerivacion
    }
  },

  watch: {
    
    dataForm:{
      deep: true,
      handler(newValue){
        this.$store.commit("setDerivacionesDataForm", { ...newValue } );
      }
    },

    stData:{
      deep: true,
      immediate: true,
      handler(newValue){
        if(this.loadInicial) return;
        this.loadInicial = true;
        this.dataForm.cuadroClinico    = newValue.cuadroClinico;
        this.dataForm.hallazgos        = newValue.hallazgos;
        this.dataForm.tipoDerivacion   = newValue.tipoDocumento;
        this.dataForm.motivoDerivacion = newValue.motivoDerivacion;
        this.dataForm.esUrgente        = newValue.esUrgente;
        this.dataForm.especialidad     = newValue.especialidad;
        this.dataForm.observacion_motder = newValue.observacionMotder;
      }
    }
  },
}
</script>
<style>
  .flatpickr-wrapper{
    width: 100%;
  }
</style>